export default __webpack_public_path__ + "resources/icons/n330-72f0.png";